import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrToolbarComponent } from './hr-toolbar.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HrToolbarComponent],
    imports: [CommonModule, ToolbarModule, ButtonModule, TranslateModule],
    exports: [HrToolbarComponent],
})
export class HrToolbarModule {}
